import { NavLink } from 'react-router-dom';

import { cn } from '@/components/ui/cn';
import { KanbanIcon, Pencil, Wiki } from '@/components/ui/icons';

/**
 * The top-level area switcher: Boards ⇄ Whiteboards ⇄ Wiki. All are per-workspace areas (siblings),
 * shown as a segmented control in the slim header of each area's index page. Icons match the ones in
 * the board dropdown so the areas read the same everywhere.
 */
const tab = (active: boolean) =>
  cn(
    'flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-[13px] font-medium transition-colors',
    active ? 'bg-surface-raised text-fg-strong shadow-sm' : 'text-fg-muted hover:text-fg',
  );

export default function AreaNav() {
  return (
    <div className="flex items-center gap-1 rounded-xl bg-surface-inset p-1">
      <NavLink to="/" end className={({ isActive }) => tab(isActive)}>
        <KanbanIcon className="h-4 w-4" /> Boards
      </NavLink>
      <NavLink to="/whiteboards" className={({ isActive }) => tab(isActive)}>
        <Pencil className="h-4 w-4" /> Whiteboards
      </NavLink>
      <NavLink to="/wiki" className={({ isActive }) => tab(isActive)}>
        <Wiki className="h-4 w-4" /> Wiki
      </NavLink>
    </div>
  );
}
